import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from '@common/interfaces/id';
import { IID_GR_TASKS } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDGrTasksState extends EntityState<IID_GR_TASKS, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_GR_TASKS })
@InterfaceDataStore(InterfaceName.GR_TASKS)
export class IIDGrTasksStore extends EntityStore<IIDGrTasksState> {

  constructor() {
    super([]);
  }

}
